import React from 'react';

const AddressCell = ({data, ...rest}) => {
    const { 
        streetNumber, 
        streetName,
        streetSuffix 
    } = data;

    return (
        <span {...rest}>
            {streetNumber} {streetName} {streetSuffix}
        </span>
    );
};

export default AddressCell;